export default __webpack_public_path__ + "static/media/15_Connect-with-whanau.076007ae.jpg";